import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const target = document.getElementById('angebot')
    if (!target) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.boundingClientRect.top < 0) {
            this.element.classList.add('visible')
          } else {
            this.element.classList.remove('visible')
          }
        })
      },
      { threshold: 0 }
    )
    observer.observe(target)
  }
}
